import { Button, Selector } from '@pmi/dsm-react';
import { useEffect, useRef, useState } from 'react';
import styles from './FilterCustomSelect.module.scss';
import { Option } from '../index';
import CustomItemList from './CustomItemList';

export interface CustomItemSelectorProps {
  label: string;
  options: { [key: string]: Option[] };
  onApply: (applyItems: any[]) => void;
  selected: any[];
}

export default function FilterCustomSelect({
  label,
  options,
  onApply,
  selected = [],
}: CustomItemSelectorProps) {
  const [selectedItems, setSelectedItems] = useState<any[]>(selected ?? []);
  const tempSelectedItemsRef = useRef<any[]>(selected ?? []);
  useEffect(() => {
    setSelectedItems(selected);
    tempSelectedItemsRef.current = selected;
  }, [selected]);

  useEffect(() => {
    const allOptionValues = new Set(
      Object.values(options)
        .flat()
        .map((o: Option) => o.value),
    );
    const pruned = selectedItems.filter((item: Option) =>
      allOptionValues.has(item.value),
    );
    if (pruned.length !== selectedItems.length) {
      setSelectedItems(pruned);
      tempSelectedItemsRef.current = pruned;
    }
  }, [options]);

  return (
    <Selector
      label={`${label} ${
        selectedItems.length > 0 ? `(${selectedItems.length})` : ''
      }`}
      withIconLabel
      className={styles.filterSelector}
    >
      <div
        className={`${styles.customSelector} custom-filter-selector-contents`}
      >
        <ul className={styles.customSelectorBlock}>
          <CustomItemList
            items={options}
            selected={tempSelectedItemsRef.current}
            onCheck={(items) => {
              tempSelectedItemsRef.current = items;
            }}
          />
        </ul>
        <hr className="w-75 mx-auto" />
        <div className="filter-buttons px-3 pb-3">
          <Button
            titleText="Clear"
            size="xs"
            variant="light"
            className={styles.btnClearSelections}
            onClick={(e: Event | any) => {
              const li = document.querySelectorAll(
                `.${styles.customSelectorBlock} li.active label`,
              );
              e.preventDefault();
              e.stopPropagation();
              tempSelectedItemsRef.current = [];
              li.forEach((n: Element | HTMLLabelElement) => {
                // @ts-ignore
                setTimeout(() => n.click(), 1);
              });
            }}
          />
          <Button
            titleText="Apply"
            variant="primary"
            size="xs"
            className="filter-button apply btn-apply-pgroups btn btn-primary"
            onClick={() => {
              setSelectedItems(tempSelectedItemsRef.current);
              onApply(tempSelectedItemsRef.current);
            }}
          />
        </div>
      </div>
    </Selector>
  );
}
